import { render } from "./BundleAddToCart.vue?vue&type=template&id=4a6ccf2a&scoped=true"
import script from "./BundleAddToCart.vue?vue&type=script&lang=js"
export * from "./BundleAddToCart.vue?vue&type=script&lang=js"

import "./BundleAddToCart.vue?vue&type=style&index=0&id=4a6ccf2a&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6ccf2a"]])

export default __exports__